import React, { useState } from 'react'
import axios from 'axios'

import { useAuthContext } from "../Contexts/AuthProvider";

import { Alert, CircularProgress, Modal } from '@mui/material';
import useActivityLogger from '../Hooks/useActivityLogger';

import styles from './DeleteAccount.module.css';

interface Props {
  onDeleted: () => void,
  onClose: () => void,
}

const DeleteAccountPanel = ({ onDeleted, onClose }: Props) => {
  const { user, updateCredential } = useAuthContext();

  const postActivity = useActivityLogger();

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError(null);

    setLoading(true);

    axios
      .post('/api/users/delete', { username: user?.username, password: password })
      .then(res => {
        postActivity('delete_account', {}, user?.id);

        updateCredential(null, null);

        onDeleted();

        alert('Your account has been closed.');
      })
      .catch(error => {
        console.log(error);

        if (error.response && error.response.data) {
          setError(error.response.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Modal open>
      <div className={styles["modal"]}>
        <h2>Close Account</h2>

        <p>You are closing the account of</p>
        <p><strong>{user?.username}</strong></p>

        <p style={{ marginTop: '16px', color: '#b30000' }}>
          <strong>Note:</strong> This action is not reversible. Once an account is closed, it cannot be restored anymore.
        </p>

        <div className={styles["form-group"]}>
          <label htmlFor="confirmPassword">To proceed, please enter your password:</label>

          {error &&
            <Alert severity="error" sx={{ mt: '20px', width: '100%' }}>{error}</Alert>
          }

          <input type="password" id="confirmPassword" placeholder="Enter your password"
            value={password}
            onChange={e => setPassword(e.target.value)} />
        </div>

        <div className={styles["modal-actions"]}>
          <button className={[styles["btn"], styles["btn-secondary"]].join(' ')}
            disabled={loading}
            onClick={onClose}
          >Cancel</button>
          <button className={[styles["btn"], styles["btn-primary"]].join(' ')}
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? <CircularProgress sx={{ color: 'white' }} size='15px' /> : 'Yes, Close Account'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteAccountPanel;
